'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragList = require('./DragList');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragList).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}